module.exports = ".p-0 {\n  padding: 0 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/quote/modals/modal-delete-quote/modal-delete-quote.scss
// module id = ./web/modern/components/quote/modals/modal-delete-quote/modal-delete-quote.scss
// module chunks = 0